/**
 * application_id → ThemePalette のレジストリ。
 *
 * 新しいアプリを追加する手順:
 *   1. `palettes/<app>.ts` を作成し、`ThemePalette` を export する
 *   2. このファイルで import して `PALETTE_BY_APPLICATION_ID` に追加する
 *   3. 必要なら `tailwindColors.ts` にスケールを追加する
 */
import type { ThemePalette } from "../types";
import { CARINA_PALETTE } from "./carina";
import { HOKAGE_PALETTE } from "./hokage";
import { RENKA_PALETTE } from "./renka";
import { SAKURA_PALETTE } from "./sakura";
import { SINA_PALETTE } from "./sina";

export const DEFAULT_PALETTE: ThemePalette = SINA_PALETTE;

export const PALETTE_BY_APPLICATION_ID: Record<string, ThemePalette> = {
  [SINA_PALETTE.appId]: SINA_PALETTE,
  [CARINA_PALETTE.appId]: CARINA_PALETTE,
  [HOKAGE_PALETTE.appId]: HOKAGE_PALETTE,
  [SAKURA_PALETTE.appId]: SAKURA_PALETTE,
  [RENKA_PALETTE.appId]: RENKA_PALETTE,
};

export const resolvePalette = (
  appId: string | null | undefined,
): ThemePalette => {
  if (!appId) return DEFAULT_PALETTE;
  return PALETTE_BY_APPLICATION_ID[appId] ?? DEFAULT_PALETTE;
};
